








































































































import "./goal-setup.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment-timezone";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import RoleSelector from "./defined-role-selector.vue";
import GradeSelector from "./defined-grade-selector.vue";
import DefinedColorPicker from "./../common/defined-color-picker.vue";
import VueTagsInput from "@johmun/vue-tags-input";

let _ = require("lodash");

export default Vue.extend({
  name: "goal-copy",
  components: {
    "defined-role-selector": RoleSelector,
    "defined-grade-selector": GradeSelector,
    DefinedColorPicker,
    VueTagsInput,
  },
  props: {
    goal: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in the Target Name",
            trigger: "blur",
          },
          {
            type: "string",
            max: 40,
            message: "Please limit your Target Name to max 40 characters. Thanks!",
            trigger: "blur",
          },
        ],
        description: [
          {
            type: "string",
            max: 1200,
            message: "Please limit your Target Description to max 1,200 characters. Thanks!",
            trigger: "blur",
          },
        ],
        hashTagList: [
          {
            type: "array",
            required: true,
            message: "Please fill in the Grouping Tags",
          },
        ],
        grades: [
          {
            required: true,
            message: "Please define the status scales",
          },
        ],
        timeline: [
          {
            required: true,
            message: "Please input the Target Timeline",
          },
          {
            validator(rule, value, callback, source, options) {
              let errors = [];
              if (value[0] === "") {
                errors.push("Please input the Target Timeline");
              }

              callback(errors);
            },
          },
        ],
      },
      gradeRules: {
        name: [
          {
            required: true,
            message: "*",
            trigger: "change",
          },
          {
            type: "string",
            max: 20,
            message: "Max 20 characters.",
            trigger: "change",
          },
        ],
        from: [
          {
            type: "number",
            required: true,
            message: "*",
            trigger: "change",
          },
        ],
      },
      activePage: "",
      tag: "",
      tags: [],
      currentGoal: {
        name: null,
        description: "",
        hashTags: "",
        hashTagList: [],
        gradeModel: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: [],
        grades: [],
        members: [],
      },
    };
  },
  watch: {
    showModal(newVal) {
      this.gotoPage("details");

      if (newVal === true) {
        this.currentGoal.name = this.goal.name;
        this.currentGoal.description = this.goal.description;
        this.currentGoal.hashTags = this.goal.hashTags;
        this.currentGoal.hashTagList = this.currentGoal.hashTags ? JSON.parse(this.currentGoal.hashTags) : [];
        this.currentGoal.timezoneOffset = new Date().getTimezoneOffset();
        this.currentGoal.timezoneName = moment.tz.guess();
        this.currentGoal.timeline = this.goal.timeline;
        this.currentGoal.members = this.goal.members;
        this.currentGoal.gradeModel = this.goal.gradeModel;
        this.currentGoal.grades = this.currentGoal.gradeModel ? JSON.parse(this.currentGoal.gradeModel) : [];
      }
    },
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    },
    getDurationString(): any {
      let timeline = this.currentGoal.timeline;
      if (timeline != null && timeline.length == 2) {
        let end = moment(timeline[1]);
        let start = moment(timeline[0]);

        let duration = end.diff(start, "days");
        return `${duration} Day(s)`;
      } else {
        return "";
      }
    },
    detailsCompleted(): any {
      let goal = this.currentGoal;
      return goal.name != null && goal.hashTagList.length > 0 && goal.timeline.length === 2;
    },
    measurementCompleted(): any {
      return this.currentGoal.grades.length > 0;
    },
  },
  methods: {
    handleSelectDefinedGrade(item) {
      this.currentGoal.grades = item.grades.map((grade) => {
        return Object.assign({}, grade);
      });
    },
    handleRemoveGrade(grade) {
      for (var i = 0; i < this.currentGoal.grades.length; i++) {
        if (this.currentGoal.grades[i] === grade) {
          this.currentGoal.grades.splice(i, 1);
        }
      }
    },
    handleAddGrade() {
      this.currentGoal.grades.push({ name: "", color: "#ED4014", from: null });
    },
    getToValue(grades, index) {
      let to = NaN;
      if (index - 1 >= 0) {
        to = grades[index - 1].from === null || isNaN(grades[index - 1].from) ? NaN : grades[index - 1].from - 1;
      } else {
        to = 100;
      }

      return isNaN(to) ? " " : `% to ${to} %`;
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.GoalForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.GoalForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let timeline = this.currentGoal.timeline;

          let goalDto = {
            id: this.goal.id,
            name: this.currentGoal.name,
            description: this.currentGoal.description,
            hashTags: JSON.stringify(this.currentGoal.hashTagList),
            gradeModel: JSON.stringify(this.currentGoal.grades),
            timezoneOffset: this.currentGoal.timezoneOffset,
            timezoneName: this.currentGoal.timezoneName,
            startDate: timeline && timeline.length === 2 ? timeline[0].toLocaleDateString() : "",
            endDate: timeline && timeline.length === 2 ? timeline[1].toLocaleDateString() : "",
            members: this.currentGoal.members,
          };

          let actionName = "goal/copy";
          let context = this;
          context.$store.dispatch(actionName, { data: goalDto }).then((response) => {
            context.$emit("cancel");
            target.disabled = false;
          });
        } else {
          target.disabled = false;
        }
      });
    },
    handlerWizardStep(forward) {
      let steps = ["details", "measurement"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.activePage) + (forward ? 1 : -1);
      this.gotoPage(steps[nextStepIndex]);
    },
    gotoPage(name) {
      this.activePage = name;
    },
  },
});
